import React from "react";

export const Resizer = ({ onMouseDown }) => {
  return (
    <div className="oc-resizer" onMouseDown={onMouseDown}>
      <svg
        style={{ position: "absolute", bottom: "-6px", right: "0" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 20L20 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M10 20L20 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 20L20 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
};
